/**
 * Every skill and template Athena publishes, for the Skills and Templates screens. ADR-0029.
 *
 * `GET /api/v1/published` answers a signed-in session and nothing else — an `ath_` token is
 * refused — so it is the one listing of the registries there is, and no assistant can read it.
 */

import { authed } from "./authed";
import type { PublishedListing } from "./types";

export function listPublished(signal?: AbortSignal): Promise<PublishedListing> {
  return authed<PublishedListing>("/published", { signal });
}
